<template>
  <v-container fluid class=" footer">
    <h3 class="black--text pa-5 ma-5 text-center">
      Got a query? Call 9999-8888-00 📱📞
    </h3>
    <v-row align-content="center" style="min-width: 90%">
      <v-col cols="6" offset-sm="1" sm="3">
        <ul class="caption">
          <p>About</p>
          <li>Create Account</li>
          <li>SignIn</li>
          <li>iOS App</li>
          <li>Android</li>
        </ul>
      </v-col>
      <!--  -->
      <v-col cols="6" sm="3">
        <ul class="caption">
          <p>Resources</p>
          <li>Help Center</li>
          <li>Advertisement</li>
          <li>Help Center</li>
          <li>Privacy & Terms</li>
        </ul>
      </v-col>
      <!--  -->
      <v-col cols="6" sm="3">
        <ul class="caption">
          <p>Company</p>
          <li>About Vue Binge Watch</li>
          <li>Jobs</li>
          <li>Careers</li>
          <li>For Business</li>
        </ul>
      </v-col>
      <!--  -->
      <v-col cols="6" sm="2">
        <ul class="caption">
          <p>Sponsored by:</p>
          <li><v-icon color="red">mdi-symfony</v-icon> Symfony</li>
          <li><v-icon color="orange">mdi-wizard-hat</v-icon> Wizard Hat</li>
          <li><v-icon color="pink">mdi-xamarin</v-icon> Xamarin</li>
          <li><v-icon color="blue">mdi-volleyball</v-icon> Volleyball</li>
          <li>
            <v-icon color="green">mdi-waze</v-icon> <strong>YOU...</strong>
          </li>
        </ul>
      </v-col>
    </v-row>

    <h1 class="pink--text text-center my-12">
      <v-icon color="pink">mdi-copyright</v-icon>
      <strong>Wasey Hasan Khan</strong>
      
    </h1>
  </v-container>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: var(--color-Grey-light-4);
}
p {
  font-size: 16px;
  font-weight: 600;
}
ul {
  list-style: none;
}
li {
  //   margin: 5px;
  font-size: 14px;
}
</style>
